<template>
    <div class="powered-footer" v-if="shouldShowPoweredFooter">
        <p>Powered by</p><LogoBanxa />
    </div>
</template>

<script setup>
import { computed } from "vue";
import LogoBanxa from "@/components/images/LogoBanxa.vue";
import { useGlobalStore } from "@/stores/globalStore";

const store = useGlobalStore();

const shouldShowPoweredFooter = computed(() => {
  return store.getIsGreyLabel
})

</script>
<style lang="scss">
.powered-footer{
    display: flex;
    align-items:center;
    margin-bottom: 3em;

    img {
        padding-left: 0.7em;
    }
}
</style>